import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type HeaderContext, type ColumnMeta, type SortDirection } from '@tanstack/react-table';

import { Button } from 'src/registry/ui/Button';

interface DataTableColumnHeaderMeta<TData, TValue> extends ColumnMeta<TData, TValue> {
    title: string;
}

interface DataTableColumnHeaderProps<TData, TValue> extends HeaderContext<TData, TValue> {
    title?: string;
}

export function DataTableColumnHeader<TData, TValue>({ column, title }: DataTableColumnHeaderProps<TData, TValue>) {
    const metaTitle = (column.columnDef.meta as DataTableColumnHeaderMeta<TData, TValue>)?.title;

    const getSortIcon = (sort: false | SortDirection) => {
        if (sort === 'desc') return <FontAwesomeIcon icon={faSortDown} />;
        else if (sort === 'asc') return <FontAwesomeIcon icon={faSortUp} />;
        else return <FontAwesomeIcon icon={faSort} className="" />;
    };

    const { enableSorting } = column.columnDef;

    if (enableSorting)
        return (
            <Button
                variant="ghost"
                size="sm"
                className="-ml-3 data-[state=open]:bg-gray-200 data-[state=open]:text-gray-900"
                onClick={column.getToggleSortingHandler()}
            >
                {title ?? metaTitle}
                {enableSorting && getSortIcon(column.getIsSorted())}
            </Button>
        );

    return title ?? metaTitle;
}

export default DataTableColumnHeader;
